module.exports = __webpack_public_path__ + "static/img/4.0e1860d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/static/image/4.jpg
// module id = 2Jms
// module chunks = 0